import CloseIcon from '@mui/icons-material/Close';
import { Dialog, styled, Box as MuiBox } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.common.white}`,
    borderRadius: '0.375rem',
    width: '100%',
    maxWidth: '37.5rem',
    padding: '1.5rem',

    [theme.breakpoints.up('sm')]: {
      margin: '2rem',
      borderRadius: '0.375rem',
    },
  },
}));

export const Content = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  gap: '1.5rem',
}));

export const OptionsContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  gap: '1.5rem',
  marginTop: '1.5rem',
});

export const CloseBox = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const CloseIconStyled = styled(CloseIcon)(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.common.white,
  '&:hover': {
    color: theme.palette.grey[600],
  },
}));
